import React, { useState, useContext } from 'react'
import { texasVptsReportPath } from 'components/routes/external'
import { createReviewWithRatingPath, reviewWithRatingPath } from 'components/routes/path'
import { AuthContext, USER_TYPES } from 'components/common/auth/AuthContext'

export interface OneClickReviewProps {
  supplierId: string
}

const OneClickReview: React.FC<OneClickReviewProps> = ({ supplierId }) => {
  const authContext = useContext(AuthContext)

  const [filled, setFilled] = useState(0)

  const ratingArray = (): number[] => Array.from({ length: 5 }, (_, i) => i + 1)

  const linkPath = (rating: number): string => {
    if (authContext.isTxVpts) {
      return texasVptsReportPath()
    } else if (authContext.userType === USER_TYPES.UNAUTHED) {
      return reviewWithRatingPath(supplierId, rating)
    } else {
      return createReviewWithRatingPath(supplierId, rating)
    }
  }

  const renderStar = (rating: number): React.ReactElement => {
    return (
      <a
        className={`rating-star rating-${rating}`}
        key={`star-${rating}`}
        onMouseEnter={() => setFilledValue(rating)}
        onMouseLeave={clearFilledValue}
        href={linkPath(rating)}
        data-method={authContext.userType === USER_TYPES.UNAUTHED ? 'get' : 'post'}
        data-testid={`star-${rating}`}
      >
        <i className={`fas fa-star${filled < rating ? ' grey-c' : ''}`} />
      </a>
    )
  }

  const setFilledValue = (rating: number): void => {
    setFilled(rating)
  }

  const clearFilledValue = (): void => {
    setFilled(0)
  }

  return (
    <div className='text-center'>
      {ratingArray().map(item => renderStar(item))}
    </div>
  )
}

export default OneClickReview
